webpackJsonp([229013805350403],{

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppPage = function AppPage() {
	  return _react2.default.createElement(
	    'main',
	    { className: 'container' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement('meta', { charSet: 'utf-8' }),
	      _react2.default.createElement(
	        'title',
	        null,
	        'CrossFit Secaucus App'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'Download the CrossFit Secaucus mobile app for your phone now.' }),
	      _react2.default.createElement('meta', { property: 'og:title', content: 'CrossFit Secaucus App' }),
	      _react2.default.createElement('meta', { property: 'og:description', content: 'Download the CrossFit Secaucus mobile app for your phone now.' }),
	      _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	      _react2.default.createElement('meta', { property: 'og:url', content: 'https://crossfit-secaucus.com/app' }),
	      _react2.default.createElement('meta', { property: 'og:image', content: 'https://crossfit-secaucus.com/img/iphone-x-og.png' }),
	      _react2.default.createElement('meta', { name: 'apple-itunes-app', content: 'app-id=1447284609' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'features-4' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'title text-center' },
	        'Get the CrossFit Secaucus App'
	      ),
	      _react2.default.createElement(
	        'h5',
	        { className: 'text-center description' },
	        'Get daily updates for the upcoming workout, and track your strength performance.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row', style: { padding: '50px 0' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-5 ml-auto ' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://itunes.apple.com/us/app/crossfit-secaucus/id1447284609', className: 'btn btn-success btn-block btn-round' },
	            'Download iOS App'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-5  mr-auto' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://play.google.com/store/apps/details?id=com.rokatu.burpee', className: 'btn btn-info btn-block btn-round' },
	            'Download Android App'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-3 col-md-12 ml-auto order-2 order-lg-1' },
	          _react2.default.createElement(
	            'div',
	            { className: 'info info-horizontal' },
	            _react2.default.createElement(
	              'div',
	              { className: 'icon icon-info' },
	              _react2.default.createElement(
	                'i',
	                { className: 'material-icons' },
	                '\uEB43'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'description' },
	              _react2.default.createElement(
	                'h4',
	                { className: 'info-title' },
	                'Strength'
	              ),
	              _react2.default.createElement(
	                'p',
	                { style: { fontSize: '1.1rem', lineHeight: '1.5rem' } },
	                'The app makes it incredibly easy to track your 1-rep max for the major lifts: front squat, overhead press, deadlift and bench press. It automatically calculates the weight for each set, and it even shows you a breakdown of the plates needed on the barbell.'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-4 col-md-12 order-1 order-lg-2' },
	          _react2.default.createElement(
	            'div',
	            { className: 'phone-container' },
	            _react2.default.createElement('img', { src: '/img/iphone-x.png' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-lg-3 col-md-12 mr-auto order-3 order-lg-3' },
	          _react2.default.createElement(
	            'div',
	            { className: 'info info-horizontal' },
	            _react2.default.createElement(
	              'div',
	              { className: 'icon icon-primary' },
	              _react2.default.createElement(
	                'i',
	                { className: 'material-icons' },
	                '\uE92C'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'description' },
	              _react2.default.createElement(
	                'h4',
	                { className: 'info-title' },
	                'Workout'
	              ),
	              _react2.default.createElement(
	                'p',
	                { style: { fontSize: '1.1rem', lineHeight: '1.5rem' } },
	                'See what the workout will be the day before, and view the past week\'s workouts conventiently on your phone.'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = AppPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-app-js-39a2ff60f267799be063.js